import {
    GetAllResources,
    GetFilteredResources, GetResource
} from "../../api/SpineClient";
import GlobalConstants from "../../config/GlobalConstants";

//API METHODS

export async function GetFilteredSubscriptions(accountId, filter){
    return await GetFilteredResources('api/accounts/' + accountId + '/subscriptions', filter);
}

export async function GetProductsByIaps(iaps) {
    return await GetAllResources('api/products/byIaps?iaps=' + iaps);
}

export async function GetPermissionsInitialPurchase(filter){
    return await GetFilteredResources('api/premiumAccessFeatures/search/by-purchase-permissions', filter);
}

export async function GetPermissionsUpgradePurchase(filter){
    return await GetFilteredResources('api/premiumAccessFeatures/search/by-current-premium-access', filter);
}

export async function GetPlanVariant(planVariantId) {
    return await GetResource(`api/billwerk/product/planvariant?planVariantId=${planVariantId}`,
        "application/json",
        {},
        GlobalConstants.SPINE_HOST);
}

export async function GetPremiumAccessFeatureByPlanVariantId(planVariantId) {
    return await GetResource(`api/premiumAccessFeatures/search/by-planVariantId?planVariantId=${planVariantId}`,
        "application/json",
        {},
        GlobalConstants.SPINE_HOST);
}

export async function GetDiscountCodes(accountId) {
    return await GetFilteredResources('api/accounts/' + accountId + '/discountCodes');
}